import React from 'react';
import Button from 'screens/components/basic/Button';
import SelectInput from 'screens/components/basic/SelectInput';
import CheckInput from 'screens/components/basic/CheckInput';
import LOOKUP from 'constants/lookup';
import DatePickerInput from 'screens/components/basic/DatePickerInput';
import VisibilityIcon from '@mui/icons-material/Visibility';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import MultiSelectInput from 'screens/components/basic/MultiSelectInput';
import BranchSelectAutoCompleteInput from 'screens/components/basic/BranchSelectAutoCompleteInput';
import CardSimple from 'screens/components/basic/CardSimple';

const componentName = "ReOrderReport";

const Header = (props) => (
    <CardSimple className="p-1">
        <div className="row row_margin_none">
            <div className="col-xs-6 col-sm-6 col-md-2 col-lg-2 col-xl-3">
                <DatePickerInput
                    name={componentName + LOOKUP.report.common.selectedDate.name}
                    floatingLabelText={LOOKUP.report.common.selectedDate.label + "*"}
                    hintText={LOOKUP.report.common.selectedDate.label + "*"}
                    fullWidth={true}
                />
            </div> {/* .col */}
            <div className="col-xs-12 col-sm-6 col-md-3 col-lg-3 col-xl-3">
            <BranchSelectAutoCompleteInput
                                    name={componentName + LOOKUP.report.common.branchName}
                                    label={LOOKUP.report.common.branch + "*"}
                                />
            </div>
            <div className="col-xs-12 col-sm-6 col-md-3 col-lg-3 col-xl-3">
                <SelectInput
                    name={componentName + "Category"}
                    fullWidth={true}
                    defaultValue="0"
                    label={"Type"}
                    floatingLabelText={"Type"}
                    hintText={"Type"}
                    options={props.categories && props.categories.length > 0 ? props.categories : []}
                />
            </div> {/* .col */}
            <div className="col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-3">
                <SelectInput
                    name={componentName + "SelectedCategory"}
                    fullWidth={true}
                    label={"Category"}
                    floatingLabelText={"Category"}
                    hintText={"Category"}
                    defaultValue="0"
                    options={props.productcategories && props.productcategories.length > 0 ? props.productcategories : []}
                />
            </div> {/* .col */}
            <div className="col-xs-12 col-sm-6 col-md-2 col-lg-2 col-xl-3">
                <SelectInput
                    name={componentName + "Weight"}
                    fullWidth={true}
                    label={"Weight"}
                    floatingLabelText={"Weight"}
                    hintText={"Weight"}
                    defaultValue="0"
                    options={props.weightOptions && props.weightOptions.length > 0 ? props.weightOptions : []}
                />
            </div> {/* .col */}

            <div className="col-xs-12 col-sm-6 col-md-3 col-lg-3 col-xl-3">
                <SelectInput
                    name={componentName + "Species"}
                    fullWidth={true}
                    label={"Species"}
                    floatingLabelText={"Species"}
                    hintText={"Species"}
                    defaultValue="0"
                    options={props.speciesOptions && props.speciesOptions.length > 0 ? props.speciesOptions : []}
                />
            </div>
            <div className="col-xs-12 col-sm-6 col-md-3 col-lg-3 col-xl-3">
                <SelectInput
                    name={componentName + "Methods"}
                    fullWidth={true}
                    defaultValue="1"
                    label={"Order By"}
                    floatingLabelText={"Order by"}
                    hintText={"Method"}
                    options={props.methods && props.methods.length > 0 ? props.methods : []}
                />
            </div> {/* .col */}

            <div className="col-xs-12 col-sm-6 col-md-2 col-lg-2 col-xl-3">
                <SelectInput
                    name={componentName + "NumOfWeeks"}
                    fullWidth={true}
                    defaultValue="1"
                    label={"Historical Data Range"}
                    floatingLabelText={"Historical Data Range"}
                    hintText={"Historical Datas Range"}
                    options={props.numOfWeeksOptions && props.numOfWeeksOptions.length > 0 ? props.numOfWeeksOptions : []}
                />
            </div>
            <div className="col-xs-12 col-sm-6 col-md-2 col-lg-2 col-xl-3">
                <SelectInput
                    name={componentName + "POFrequency"}
                    fullWidth={true}
                    defaultValue="1"
                    label={"PO Every:"}
                    floatingLabelText={"PO Every:"}
                    hintText={"PO Every:"}
                    options={props.numOfWeeksOptions && props.numOfWeeksOptions.length > 0 ? props.numOfWeeksOptions : []}
                />
            </div>
        </div>
        <div className="row row_margin_none">
            <div className="col-xs-12 col-md-9">
                <CheckInput
                    name={componentName + "HideZero"}
                    text="Only display products that have available inventory or were recently purchased (within 30 days)."
                />
            </div>
            <div className="col-xs-12 col-md-3 pull-right">
                <MultiSelectInput
                    defaultValues={localStorage.getItem("ReOrderReportCsvColumns") != null ? localStorage.getItem("ReOrderReportCsvColumns").split(",").map(item => { return ({ value: item }) }) : 0}
                    name={`${componentName}CsvColumns`}
                    fullWidth={true}
                    autoWidth={true}
                    label="CSV Columns to Include"
                    floatingLabelText="CSV Columns to Include"
                    hintText="CSV Columns to Include"
                    style={{ fontFamily: "Open Sans, Arial, Helvetica, sans-serif", fontSize: "16px", letterSpacing: "-0.25px" }}
                    options={props.csvColumnOptions}
                    fieldName={'CsvColumns'}
                />
            </div> {/* .col */}
            <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                <Button
                    type="IconInButton"
                    className="pull-right mt-2 ml-1 btnNewBrandPOS"
                    name={componentName + LOOKUP.report.common.viewReport.name}
                    label={LOOKUP.report.common.viewReport.label}
                    icon={<VisibilityIcon />}
                    onTouchTap={props.showBody}
                />
                <Button
                    type="DownloadButton"
                    className="pull-right mt-2 btnNewBrandPOS"
                    name={componentName + LOOKUP.report.common.downloadReport.name}
                    label={LOOKUP.report.common.downloadReport.label}
                    onTouchTap={props.download}
                />
            </div>
            <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                <p className='purpleText'><b>Note: </b><strong className="blue-text"><i>Inventory only counts store and storage warehouse, value sold are the value after discounts.</i></strong></p>
                <p><strong className="blue-text"><i>If restock cap for a product is not set, this report uses an average value based on previous sales history.</i></strong></p>
            </div>
        </div>
    </CardSimple>
);
export default Header;
